<template>
<div class="tab-pane active" id="step4">
	<div v-if="store.tmp.current_tab === 'articles'">
		<h2 class="hidden-lg">{{ $t("tab.articles") }}</h2>
		<div class="row">
			<div class="">
				<div class="articles-block">
					<ol class="breadcrumb breadcrumb-block" v-show="breadCrumbs.length > 0">
						<li
							class="breadcrumb-item"
							v-for="breadcrumb, key in breadCrumbs"
							:key="key"
							:class="key === breadCrumbs.length-1 ? 'active' : ''">
							<span @click="goToBreadCrumb(key)">{{ breadcrumb.displayName }}</span>
						</li>
					</ol>

					<div class="article-presenter">
						<div class="row" v-if="breadCrumbs.length > 1">
							<div class="col-md-12">
								<span class="btn" @click="goToPreviousBreadCrumb">
									<i class="fa fa-chevron-left"></i> {{ $t('buttons.prev') }}
								</span>
							</div>
						</div>

						<div class="row" v-if="showWelcomeMessage">
							<div class="col-md-12">
								<pre v-html="welcomeMessage" class="box-for"></pre>
							</div>
						</div>

						<div class="article-categories-block" v-show="breadCrumbs.length === 1">
							<div class="article-categories col-md-6" v-for="category,cIndex in translatedCategory" :key="cIndex">
								<h4 class="category-label col-md-12" @click="pushBreadCrumb(category)">{{ category.displayName }}<i class="fa fa-plus"></i></h4>
							</div>
						</div>

						<div class="articel-row" v-if="breadCrumbs[breadCrumbs.length-1] != null">
							<div v-for="article in availableArticles"
								class="article-frame col-xs-12 col-lg-6"
								:key="article.id">
								<ConfiguratorArticle
									:article="article"
									:days-to-go="daysToGo"
									@add="addToBasket"
									@update="updateBasket"
									@setSquareMeter="setSquareMeter"
									@remove="removeFromBasket" />
							</div>
						</div>

						<div class="row" v-if="breadCrumbs[breadCrumbs.length-1] != null">
							<div v-for="subcategory,sIndex in breadCrumbs[breadCrumbs.length-1].subCategories"
								:key="sIndex"
								class="col-md-4">
								<span class="subcategory-label col-md-12" @click="pushBreadCrumb(subcategory)">
									{{ subcategory.displayName }}<i class="fa fa-plus"></i>
								</span>
							</div>
						</div>
					</div>

					<div class="row" v-if="breadCrumbs.length > 1">
						<div class="col-md-12">
							<span class="btn" @click="goToPreviousBreadCrumb">
								<i class="fa fa-chevron-left"></i> {{ $t('buttons.prev') }}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row" v-if="!isExhibitionClosed">
			<div class="col-md-12">
				<hr>

				<div class="wizard-footer">
					<div v-show="hasPrintableArticlesSelected" class="pull-right">
						<a href="#">
							<input
								type='button'
								class='btn btn-next btn-warning'
								name='next'
								:value='($t("tab.prints") + " " + $t("buttons.next_to"))'
								@click="store.updateCurrentTab('prints')" />
						</a>
					</div>

					<!--<div v-show="!hasPrintableArticlesSelected" class="pull-right">
						<a href="#" @click="skipToSummary"> 
							<input
								type='button'
								class='btn btn-next btn-warning btn-next-summary'
								name='next'
								:value='($t("tab.summary") + " " + $t("buttons.next_to"))' />
						</a>
					</div>-->

					<div class="pull-left" v-if="store.tmp.selected_booth !== null">
						<input
							type='button'
							class='btn btn-previous btn-warning'
							name='previous'
							:value='($t("buttons.prev_to") + " " + $t("tab.booth_set_up"))'
							@click="store.updateCurrentTab('booth_setup')" />
					</div>
				</div>

				<div v-show="!hasPrintableArticlesSelected" class="pull-right">
					<button
						type='button'
						class='btn btn-warning'
						@click="skipToSummary">
						{{ $t("tab.summary") + " " + $t("buttons.next_to") }}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useMainStore } from '@/store'
import { useI18n } from 'vue-i18n'
import _ from 'lodash'
import { ARTICLE_TYPE_DEFAULT, ARTICLE_TYPE_PRINTABLE } from '@/constants'
import ConfiguratorArticle from './configurator/ConfiguratorArticle.vue'
import Swal from 'sweetalert2'

const { t } = useI18n({ useScope: 'global' })
const store = useMainStore()
// define passed props
const props = defineProps({
  basket: {
    type: Object,
    required: true,
  },
  views: {
    type: Object,
    required: true,
  },
  welcomeMessage: {
    type: String,
    default: '',
  },
  isRestrictedAccess: {
    type: Boolean,
    default: false,
  },
  daysToGo: {
    type: Number,
    default: 0,
  },
  isExhibitionClosed: {
    type: Boolean,
    default: false,
  },
})
// define emits
const emit = defineEmits(['saveBasket', 'resetDisplayedBooth'])
// define reactive props
const breadCrumbs = ref([{displayName: t('categories.all')}])
// define computed props
const shoppingCart = computed(() => store.settings.shopping_cart)
const checklist = computed(() => store.checklist)
const inEnglish = computed(() => store.inEnglish)
const categories = computed(() => store.tmp.categories)

const translatedCategory = computed(() => {
	let visibleCategories = categories.value.filter((category) => !category.hidden_in_configurator)
	for (let i = 0; i < visibleCategories.length; i++) {
		visibleCategories[i]['displayName'] = (inEnglish.value)
			? visibleCategories[i].name_en
			: visibleCategories[i].name
		if (
			visibleCategories[i]['subCategories'] != null
			&& visibleCategories[i]['subCategories'].length > 0
		) {
			for (let n = 0; n < visibleCategories[i]['subCategories'].length; n++) {
				const subCategory = visibleCategories[i]['subCategories'][n]
				visibleCategories[i]['subCategories'][n]['displayName'] = (inEnglish.value)
					? subCategory.name_en
					: subCategory.name
			}
		}
	}

	return visibleCategories
})

const showWelcomeMessage = computed(() => {
	return props.welcomeMessage && props.isRestrictedAccess
})

const availableArticles = computed(() => {
	if (!breadCrumbs.value[breadCrumbs.value.length-1].hasOwnProperty('articles')) {
		return []
	}

	return breadCrumbs.value[breadCrumbs.value.length-1].articles
		.filter((article) => {
			return article.pivot.deleted_at === null
				&& (article.type === ARTICLE_TYPE_DEFAULT || article.type === ARTICLE_TYPE_PRINTABLE)
		})
})

const hasPrintableArticlesSelected = computed(() => {
	let selected = false
	for (const article of shoppingCart.value.items) {
		if (article.type === ARTICLE_TYPE_PRINTABLE) {
			selected = true
			break
		}
	}

	return selected
})
// define methods
const pushBreadCrumb = (breadcrumb) => {
	breadCrumbs.value.push(breadcrumb)
}

const goToBreadCrumb = (index) => {
	breadCrumbs.value = breadCrumbs.value.slice(0, index + 1)
}

const goToPreviousBreadCrumb = () => {
	breadCrumbs.value = breadCrumbs.value.slice(0, breadCrumbs.value.length - 1)
}

const setSquareMeter = (article) => {
	if (
		article.unit === 'sqm'
		&& article.count === 0
		&& (parseFloat(props.basket.width) * parseFloat(props.basket.depth) > 0)
	) {
		article.count = (parseFloat(props.basket.width) * parseFloat(props.basket.depth))
		emit('saveBasket')
	}
}

const addToBasket = (article) => {
	if (
		article.unit === 'sqm'
		&& article.count === 0
		&& (parseFloat(props.basket.width) * parseFloat(props.basket.depth) > 0)
	) {
		article.count = (parseFloat(props.basket.width) * parseFloat(props.basket.depth))
	} else {
		article.count = Math.round(article.count + 1)
	}
	// cloning article to prevent interference with old basket
	const clonedArticle =  _.cloneDeep(article)
	shoppingCart.value.addArticle(clonedArticle)
	if (clonedArticle.type === ARTICLE_TYPE_PRINTABLE) {
		addPrintArticle(clonedArticle)
  }

	emit('saveBasket')
}

const removeFromBasket = (article) => {
	article.count = Math.round(article.count - 1)
	// cloning article to prevent interference with old basket
	const clonedArticle =  _.cloneDeep(article)
	shoppingCart.value.removeArticle(clonedArticle)
	if (clonedArticle === ARTICLE_TYPE_PRINTABLE) {
		removePrintArticle(clonedArticle)
	}

	emit('saveBasket')
}

const addPrintArticle = (article) => {
	for (const printArticle of article.prints) {
		const index = props.basket.selectedArticles.findIndex((item) => item.id === printArticle.print_article_id)
		if (index > -1) {
			const clonedPrintArticle = _.cloneDeep(props.basket.selectedArticles[index])
			shoppingCart.value.addPrintArticle(clonedPrintArticle, printArticle)
		} else {
			console.warn('no print article found')
		}
	}
}

const removePrintArticle = (article) => {
	for (const printArticle of article.prints) {
		shoppingCart.value.removePrintArticle(article, printArticle.id)
	}
}

const skipToSummary = async (e) => {
	if (checklist.value.minimum_checkout) {
		emit('resetDisplayedBooth')
		store.updateCurrentTab('summary')
	} else {
		Swal.fire({
			title: t('configurator.notices.titles.minimum_checkout'),
			html: t('configurator.notices.messages.minimum_checkout'),
			showCancelButton: false,
			confirmButtonText: t('configurator.buttons.ok'),
		})
	}
}

const updateBasket = (article) => {
	const clonedArticle =  _.cloneDeep(article)
	shoppingCart.value.updateArticleAmount(clonedArticle)
	if (article.count > 0) {
		if (clonedArticle.type === ARTICLE_TYPE_PRINTABLE) {
			addPrintArticle(clonedArticle)
		}
	} else {
		if (clonedArticle.type === ARTICLE_TYPE_PRINTABLE) {
			removePrintArticle(clonedArticle)
		}
	}

	emit('saveBasket')
}
</script>
